import React from 'react';
export function Leadership() {
  return <section className="py-24 md:py-32 px-6 bg-navy text-white" data-id="element-54">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-55">
        <h2 className="text-3xl md:text-4xl text-white" data-id="element-56">Leadership</h2>

        <div className="w-12 h-px bg-white/20 mx-auto" data-id="element-57"></div>

        <p className="text-lg md:text-xl text-gray-300 font-light leading-relaxed" data-id="element-58">
          MFC Investco is guided by experienced, values-driven leadership
          committed to the principles of integrity and service. We operate
          privately and selectively, bringing decades of expertise in finance,
          operations, and governance to every partnership.
        </p>

        <p className="text-sm text-gray-400 uppercase tracking-widest pt-4" data-id="element-59">
          Operating Privately & Selectively
        </p>
      </div>
    </section>;
}